import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import Tr from './Tr';
/**
 * @ReactComponent
 *
 * 表格行
 *
 * @export
 * @param {any} props
 * @param {any} context
 * @returns
 */
var TableRow = function (props, context) {
    var _a = props.selected, selected = _a === void 0 ? false : _a, _b = props.type, type = _b === void 0 ? 'body' : _b;
    var typeHead = (context.table && context.table.head) || props.type === 'head';
    var typeFooter = (context.table && context.table.footer) || props.type === 'footer';
    return React.createElement(Tr, tslib_1.__assign({}, props, { typeHead: typeHead, typeFooter: typeFooter }));
};
TableRow.contextTypes = {
    table: PropTypes.object,
};
export default TableRow;
//# sourceMappingURL=TableRow.js.map